import React from 'react';
import './GameHeader.scss';

function GameHeader({ tourCourant, totalTours, joueurActifNom, joueurActifCouleur, children }) {
  return (
    <div className="game-header">
      <div className="header-left">
        <h1>MEMOZYN</h1>
        <h2>Tour : {tourCourant}/{totalTours}</h2>
      </div>
      
      <div className="header-right">
        <div className="header-top-row">
          <div className="joueur-actif">
            Joueur actif : <span style={{ color: joueurActifCouleur, fontWeight: '900', marginLeft: '5px' }}>{joueurActifNom}</span>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}

export default GameHeader;